import React, { type FC } from "react";
import a11y from "../../../../../shared-components/css-modules/lexus/utils/Accessibility.module.scss";
import { useCarConfigSelector } from "../../../../redux/store";

const LiveRegions: FC = () => {
    const liveRegions = useCarConfigSelector((state) => state.notification?.notifications);

    return (
        <ul aria-live="polite" aria-atomic="false" className={a11y["sr-only"]}>
            {liveRegions?.map((liveMessage, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`${index}-${liveMessage.title}-${liveMessage.description as string}`}>
                    {/* Done like this so it renders as a single string. Otherwise it messes with the voiceover */}
                    {`${liveMessage.title} ${liveMessage.description || ""}`}
                </li>
            ))}
        </ul>
    );
};

export default LiveRegions;
